import * as types from './types'

export default {
  [types.SET_STATUSES](state, data) {
    state.statuses = data
  },
  [types.SET_REQUESTS](state, data) {
    state.requests = data
  },
  [types.SET_TOOLS](state, data) {
    state.tools = data
  },
  [types.SET_TECHS](state, data) {
    state.techs = data
  },
  [types.SET_USERINFO](state, data) {
    state.userInfo = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/mutations.js